export default __webpack_public_path__ + "static/media/translating.aa6ee884.webp";